import { PlaceSummary } from 'common/src/app/types/PlaceSummary';

/* Build up the display name */
/* Filters out characters - such as undefined, null, or ''. */
/* If county_unitary is null - use the region field */
export const getFormattedPlaceName = (place?: PlaceSummary): string =>
  [place?.name_1, place?.county_unitary || place?.region, place?.outcode]
    .filter(Boolean)
    .join(', ');
